// Snapshot of in-progress work persisted to localStorage so a crash or
// accidental tab close doesn't lose results. Cleared on successful completion
// or when the user explicitly starts a new cleanse.

const RECOVERY_KEY = "addressCleanseRecovery";
const RECOVERY_TTL_MS = 24 * 60 * 60 * 1000;

export interface RecoverySnapshot {
  progress: { done: number; total: number };
  resultRows: any[];
  originalRows: any[];
  csvHeaders: string[];
  line1Col: string;
  postcodeCol: string;
  timestamp: number;
}

export function loadRecovery(): RecoverySnapshot | null {
  try {
    const saved = localStorage.getItem(RECOVERY_KEY);
    if (!saved) return null;
    const data = JSON.parse(saved);
    if (Date.now() - data.timestamp >= RECOVERY_TTL_MS) return null;
    return data;
  } catch (error) {
    console.error("Error loading recovery data:", error);
    return null;
  }
}

export function saveRecovery(snapshot: Omit<RecoverySnapshot, "timestamp">) {
  const payload: RecoverySnapshot = { ...snapshot, timestamp: Date.now() };
  localStorage.setItem(RECOVERY_KEY, JSON.stringify(payload));
}

export function clearRecovery() {
  localStorage.removeItem(RECOVERY_KEY);
}

export function hasResumableWork(snap: RecoverySnapshot | null): boolean {
  return !!snap && snap.progress.done < snap.progress.total;
}
